import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import QuemSomosSection from './components/QuemSomosSection';
import ComoFuncionaSection from './components/ComoFuncionaSection';
import ProjetosDestaque from './components/ProjetosDestaque';
import PorQueConfiar from './components/PorQueConfiar';
import Depoimentos from './components/Depoimentos';
import FAQ from './components/FAQ';
import CTAFinal from './components/CTAFinal';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <QuemSomosSection />
        <ComoFuncionaSection />
        <ProjetosDestaque />
        <PorQueConfiar />
        <Depoimentos />
        <FAQ />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}
